export const authRoles = {
    admin: ['global'],
    jobs: ['global', 'job_write'],
    users: ['global', 'user_write'],
    credentials: ['global', 'credential_write']
}
